import React from 'react';
import '../../news-pages.css'
import Parse from 'html-react-parser'

import OwlCarousel from 'react-owl-carousel'
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel/dist/assets/owl.theme.default.css'

import cover from './cover.jpg'
import pic1 from './pic1.jpg'
import pic2 from './pic2.jpg'
import pic3 from './pic3.jpg'





const Id2 = () => {

    const detail = 
        {
            id:29,
            imgSrc:cover,
            ini:'Congratulates Mr. Nyein Linn Maung on Winning AMS Research Award 2026',
            href:'',
            element:'',
            topic:'Congratulations to Mr. Nyein Linn Maung, a Master’s student from the Faculty of Associated Medical Sciences, Chiang Mai University, on receiving the "3rd Presentation Award" for his graduate research presentation at The AMS Research Symposium for Graduate Students 2026, held from May 28 to 29, 2026. <br>The award-winning research was presented under the topic “Development of Metagenomic Analysis of Respiratory Viruses in PM2.5 filters,” a research project proudly funded by the PRESTO project.<br> On this auspicious occasion, the IJL PRESTO highly commends the student’s dedication, hard work, and commitment to his research. We wish him continued success, academic excellence, and further advancement in his future research and academic career.',
            inform:``,
            link1:`https://www.facebook.com/permalink.php?story_fbid=pfbid02iSBSMmcW7ZBEWwakWv9Qhh7TRcdvE8Yb6AMW1Ln6WsXNFtGr286VSDyZnkjoc76Ul&id=100089824854973`, 
        }
    
        const handleLink1 = () =>{
            window.open(detail.link1, '_blank', 'noreferrer')
        }

    const imgs = [
        {
            imageSrc: cover,
            alt: 'cover',
            title: 'cover',
            thumbnailImageSrc: cover
        },
        {
            imageSrc: pic1,
            alt: 'pic1',
            title: 'pic1',
            thumbnailImageSrc: pic1
        },
        {
            imageSrc: pic2,
            alt: 'pic2',
            title: 'pic2',
            thumbnailImageSrc: pic2
        },
        {
            imageSrc: pic3,
            alt: 'pic3',
            title: 'pic3',
            thumbnailImageSrc: pic3
        },
      
    ]

    return (
        <div className='elements containers'>
            <div className="img-slicer">
                <OwlCarousel
                    className='owl-theme'
                    loop={true}
                    margin={10}
                    lazyLoad={true}
                    nav
                    items={1}
                    autoplay={true}
                    autoplayTimeout={3000}
                    autoplayHoverPause={true}
                    smartSpeed={1000}
                >
                    {imgs.map((img,index)=>(
                        <div className="item" key={index}><img src={img.imageSrc} alt="item" /></div>
                    ))}
                </OwlCarousel>
            </div>
            <div className="text">
                <h1>{detail.ini}</h1>
                <h2>{Parse(detail.topic)}</h2>
                <p>{Parse(detail.inform)}</p>
                <div className="btn">
                    <h2>MORE INFORMATION</h2>
                    <button onClick={handleLink1}>{detail.link1}</button>
                </div>
            </div>
        </div>
    );
}

export default Id2;
